import { useEffect, useState } from "react";
import axiosInstance from "../components/api/axiosInstance";

let cache = null;
let pending = null;

function loadClientOptions() {
  if (cache) return Promise.resolve(cache);
  if (!pending) {
    pending = axiosInstance
      .get("/client-options")
      .then((res) => {
        const raw = Array.isArray(res.data) ? res.data : Array.isArray(res.data?.data) ? res.data.data : [];
        cache = raw.map((c) => ({
          id: String(c.Tenant_Id),
          name: c.Name,
          status: c.Status || "",
          isActive: String(c.Status || "").toLowerCase() === "active",
          domainId: c.Domain_Id != null ? String(c.Domain_Id) : "",
          domainName: c.Domain_Name || "",
        }));
        return cache;
      })
      .finally(() => {
        pending = null;
      });
  }
  return pending;
}

/** Every client (active + inactive) as [{id, name, status, isActive, domainId, domainName}], cached per page load. */
export default function useClientOptions() {
  const [clients, setClients] = useState(() => cache || []);
  useEffect(() => {
    let cancelled = false;
    loadClientOptions()
      .then((rows) => {
        if (!cancelled) setClients(rows);
      })
      .catch(() => {
        if (!cancelled) setClients([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);
  return clients;
}
